module.exports = __webpack_public_path__ + "media/images/info-6503877dae1c0d9ed1e174372c8eae61.svg";